/**
 * component-live-ticker.js
 * Custom Element <live-ticker>
 * Lot 2 Batch A — EDJ Shopify theme
 */
(function () {
  // Items par défaut — peuvent être overridés via attribut `data-items`
  // (JSON-encoded array of {name, action}) posé par la section Liquid.
  // Cf. sections/hero-editorial-animated.liquid → <live-ticker data-items="...">.
  const DEFAULT_ITEMS = [
    { name: 'Marie · Paris',    action: "vient d’acheter Yukata Sakura" },
    { name: 'Léa · Lyon',       action: 'a ajouté Bol Hagi · 12 min' },
    { name: 'Tom · Bordeaux',   action: 'a commandé Service à thé · 18 min' },
    { name: 'Inès · Nantes',    action: 'a sauvegardé 3 articles' },
    { name: 'Hugo · Rennes',    action: 'a payé sa commande · 24 min' },
  ];

  // Inject shared styles once
  function injectStyles() {
    if (document.getElementById('lt-styles')) return;
    const s = document.createElement('style');
    s.id = 'lt-styles';
    s.textContent = [
      'live-ticker{display:flex;align-items:center;gap:10px;font-size:12px;',
      'color:var(--color-ink-soft);font-family:var(--font-sans)}',
      '.lt-dot{color:#3a6e3a;flex-shrink:0;animation:lt-blink 1.6s ease-in-out infinite}',
      '@keyframes lt-blink{0%,100%{opacity:1}50%{opacity:.3}}',
      '.lt-track{position:relative;height:18px;overflow:hidden;flex:1}',
      '.lt-item{position:absolute;inset:0;display:flex;align-items:center;gap:6px;',
      'white-space:nowrap;transition:opacity .5s cubic-bezier(.2,.8,.2,1),',
      'transform .5s cubic-bezier(.2,.8,.2,1)}',
      '.lt-item[aria-hidden="true"]{opacity:0;transform:translateY(8px)}',
      '.lt-item[aria-hidden="false"]{opacity:1;transform:translateY(0)}',
      '.lt-name{font-weight:600;color:var(--color-ink)}',
      '.lt-action{font-style:italic;color:var(--color-ink-muted);',
      'font-family:var(--font-serif-text);font-size:14px}',
    ].join('');
    document.head.appendChild(s);
  }

  class LiveTicker extends HTMLElement {
    connectedCallback() {
      injectStyles();
      // Lecture items configurables : 1) attribut data-items (JSON), 2) fallback DEFAULT.
      // La section Liquid pose data-items quand l'admin a personnalisé la liste.
      this._items_data = DEFAULT_ITEMS;
      const raw = this.getAttribute('data-items');
      if (raw) {
        try {
          const parsed = JSON.parse(raw);
          if (Array.isArray(parsed) && parsed.length > 0) {
            this._items_data = parsed.filter(it => it && it.name);
          }
        } catch (e) { /* fallback DEFAULT */ }
      }
      this._current = 0;
      this._build();
      this._interval = setInterval(() => {
        this._current = (this._current + 1) % this._items_data.length;
        this._update();
      }, 3200);
    }

    disconnectedCallback() {
      clearInterval(this._interval);
    }

    _build() {
      // Dot
      const dot = document.createElement('span');
      dot.className = 'lt-dot';
      dot.setAttribute('aria-hidden', 'true');
      dot.textContent = '●';
      this.appendChild(dot);

      // Track
      const track = document.createElement('div');
      track.className = 'lt-track';
      track.setAttribute('role', 'status');
      track.setAttribute('aria-live', 'polite');
      track.setAttribute('aria-atomic', 'true');

      this._items_data.forEach((item, i) => {
        const row = document.createElement('div');
        row.className = 'lt-item';
        row.setAttribute('aria-hidden', i === 0 ? 'false' : 'true');
        row.dataset.index = String(i);

        const name = document.createElement('span');
        name.className = 'lt-name';
        name.textContent = item.name;

        const action = document.createElement('span');
        action.className = 'lt-action';
        action.textContent = item.action;

        row.appendChild(name);
        row.appendChild(action);
        track.appendChild(row);
      });

      this.appendChild(track);
      this._items = Array.from(track.querySelectorAll('.lt-item'));
    }

    _update() {
      this._items.forEach((el, i) => {
        el.setAttribute('aria-hidden', i === this._current ? 'false' : 'true');
      });
    }
  }

  if (!customElements.get('live-ticker')) {
    customElements.define('live-ticker', LiveTicker);
  }
})();
